<template>
  <div id="add-receipt">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Tạo phiếu Nhập', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter pb-5">
      <block :nobody="true" ref="breceipt" class="soft-control">
        <!-- <b-row align-v="center" class="text-center">
          <b-col><h3 class="mt-3">Báo giá mới</h3></b-col>
        </b-row>
        <hr /> -->
        <b-row class="mx-0" align-h="center">
          <b-col md="10 px-0 border-right border-info">
            <b-card class="m-3">
              <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
                <form role="form" @submit.prevent="handleSubmit(doSave)">
                  <b-row>
                    <b-col>
                      <base-input
                        :disabled="receipt.id != ''"
                        v-model="receipt.code"
                        label="Mã phiếu nhập"
                        placeholder="Không nhập hệ thống sẽ tự phát sinh"
                      >
                      </base-input>
                    </b-col>
                    <b-col>
                      <div>
                        <label for="datepicker-lg">Ngày tạo</label>
                        <b-form-datepicker
                          :disabled="receipt.id != ''"
                          id="datepicker-lg"
                          :date-format-options="{
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          }"
                          v-model="receipt.date"
                          locale="vi"
                        ></b-form-datepicker>
                      </div>
                    </b-col>
                    <b-col>
                      <base-input label="Người Tạo" readonly value="xxxx"> </base-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="4">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <base-select
                          :disabled="receipt.id != ''"
                          v-model="receipt.customer"
                          label="Mã khách hàng"
                          :ajaxData="getCustomer"
                          :error="errors[0]"
                        >
                          <template v-slot:selected="{ item }">
                            <div>
                              {{ item.code }}
                            </div>
                          </template>
                          <template v-slot:body="{ item }">
                            <div>
                              <strong>{{ item.code }}</strong> <br />
                              <span>{{ item.name }}</span>
                            </div>
                          </template>
                        </base-select>
                      </ValidationProvider>
                    </b-col>
                    <b-col md="4">
                      <base-select
                        :disabled="receipt.id != ''"
                        v-model="receipt.customer"
                        label="Tên khách hàng"
                        :ajaxData="getCustomer"
                        ><template v-slot:selected="{ item }">
                          <div>
                            {{ item.name }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                    <b-col md="4">
                      <base-select
                        :disabled="receipt.id != ''"
                        v-model="receipt.customer"
                        label="Email khách hàng"
                        :ajaxData="getCustomer"
                        ><template v-slot:selected="{ item }">
                          <div>
                            {{ item.email }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </b-col>
                  </b-row>
                </form>
              </ValidationObserver>
              <hr />
              <table v-if="manufacture && manufacture.id" class="table soft-table">
                <thead>
                  <tr>
                    <td>
                      Mã đơn hàng : <b>{{ manufacture.order.code }}</b>
                    </td>
                    <td>
                      Mã lệnh chế tạo :
                      <b>{{ manufacture.code }}</b>
                    </td>
                  </tr>
                </thead>
              </table>
              <hr />
              <div class="d-flex">
                <h5>* Sản phẩm :</h5>
                <!-- <b-button
                  v-if="receipt.id == ''"
                  @click="productReceiptAddRow"
                  variant="success px-1 py-0 ml-2 mb-2"
                >
                  <i class="fa fa-flus" aria-hidden="true"></i> Thêm 1 dòng
                </b-button> -->
              </div>
              <base-table :data="receiptBillDetails">
                <template slot="columns">
                  <th>STT</th>
                  <th>Mã sản phẩm</th>
                  <th>Tên sản phẩm</th>
                  <th>Quy cách</th>
                  <th>Hệ màu</th>
                  <th>Màu sắc</th>
                  <th>Mã màu 1</th>
                  <th>Mã màu 2</th>
                  <th>Diễn giải</th>
                  <th>ĐVT</th>
                  <th>Chiều dài</th>
                  <th>tổng số kg/bọc</th>
                  <th>Vị trí lưu kho</th>
                  <th>Số lượng</th>
                  <th>Ghi chú</th>
                  <th></th>
                </template>

                <template slot-scope="{ row, index }">
                  <tr v-if="!row.edit" :key="index">
                    <td class="bg-info text-light col-fix ">
                      {{ index + 1 }}
                    </td>
                    <td>{{ row.product.code }}</td>
                    <td>
                      {{ row.product.name }}
                      <!-- <span v-if="row.productCustom != ''"><br />{{ row.productCustom }}</span> -->
                      <span v-if="row.reason"><br />{{ row.reason.name }}</span>
                    </td>
                    <td class="text-center">{{ row.productSpecify.name }}mm</td>
                    <td>
                      <span v-if="row.color">{{ row.color.label }}</span>
                    </td>
                    <td class="text-center">{{ row.colorText }}</td>
                    <td class="text-center">{{ row.colorCode1 }}</td>
                    <td class="text-center">{{ row.colorCode2 }}</td>
                    <td class="text-center">
                      <span v-if="row.reason">{{ row.reason.name }}</span>
                    </td>
                    <td class="text-right">{{ row.unit }}</td>
                    <td class="text-right">{{ row.length }}</td>
                    <td class="text-center">{{ row.totalKgWrap }}</td>
                    <td class="text-center">{{ row.position }}</td>
                    <td class="text-right">
                      {{ $formatNumber(row.quantity) }}
                    </td>
                    <td style="min-width:500px">
                      <p v-html="row.note"></p>
                    </td>
                    <td></td>
                  </tr>
                  <tr v-else :key="index">
                    <td class="bg-info text-light col-fix text-center">
                      {{ index + 1 }}
                    </td>
                    <td class="p-1">
                      <base-select
                        @change="productChange(row)"
                        v-model="row.product"
                        :ajaxData="getProduct"
                        placeholder="Nhập mã hoặc tên sản phẩm"
                        :error="!row.product || !row.product.id"
                      >
                        <template v-slot:selected="{ item }">
                          <div>
                            {{ item.code }}
                          </div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.code }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </td>
                    <td class="p-1">
                      <span v-if="row.product">
                        {{ row.product.name }}
                        <!-- <span v-if="row.productCustom != ''"><br />{{ row.productCustom }}</span> -->
                        <span v-if="row.reason"><br />{{ row.reason.name }}</span>
                      </span>
                    </td>
                    <td class="p-1">
                      <base-select
                        style="width:100px"
                        @change="productSpecifyChange(row)"
                        v-if="row.product && row.product.id"
                        v-model="row.productSpecify"
                        :options="row.product.productSpecifys"
                        :error="!row.productSpecify || !row.productSpecify.id"
                      >
                        <template v-slot:selected="{ item }">
                          <div>{{ item.name }} mm</div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <span>{{ item.name }} mm</span>
                          </div>
                        </template>
                      </base-select>
                      <span v-else>--Vui lòng chọn sản phẩm--</span>
                    </td>
                    <td class="p-1">
                      <color
                        @change="productColorChange(row)"
                        :error="!row.color || !row.color.id"
                        v-model="row.color"
                      ></color>
                    </td>
                    <td style="min-width:140px">
                      <base-input placeholder="Ex: Hồng phấn" class="mb-0" v-model="row.colorText"> </base-input>
                    </td>
                    <td>
                      <base-input v-model="row.colorCode1"></base-input>
                    </td>
                    <td><base-input v-model="row.colorCode2"></base-input></td>
                    <td>
                      <base-select
                        class="w-100"
                        @change="reasonChange($event, row)"
                        v-model="row.reason"
                        :ajaxData="getReason"
                      >
                        <template v-slot:selected="{ item }">
                          <div>{{ item.key }} - {{ item.name }}</div>
                        </template>
                        <template v-slot:body="{ item }">
                          <div>
                            <strong>{{ item.key }}</strong> <br />
                            <span>{{ item.name }}</span>
                          </div>
                        </template>
                      </base-select>
                    </td>
                    <td>
                      <base-input style="min-width:40px" v-model="row.unit"></base-input>
                    </td>
                    <td>
                      <base-input style="min-width:40px" v-model="row.length"></base-input>
                    </td>
                    <td>
                      <base-input :mask="'number'" v-model="row.totalKgWrap"></base-input>
                    </td>
                    <td><base-input v-model="row.position"></base-input></td>
                    <td class="p-1">
                      <base-input :mask="'number'" v-model="row.quantity"></base-input>
                    </td>
                    <td>
                      <textarea style="min-width:450px" v-model="row.note"></textarea>
                    </td>
                    <td class="col-fix text-center">
                      <div class="d-flex">
                        <b-button
                          class="mr-2"
                          variant="outline-danger px-1 py-0"
                          @click="productReceiptDeleteRow(index, row)"
                        >
                          <i class="fa fa-backspace" aria-hidden="true"></i>
                        </b-button>
                      </div>
                    </td>
                  </tr>
                </template>
              </base-table>
              <hr />
              <div class="form-group" style="overflow: hidden;">
                <label class="form-control-label" for="">Ghi chú</label>
                <ckeditor :editor="editor" v-model="receipt.note" @ready="onReady" :config="editorConfig"></ckeditor>
              </div>
            </b-card>
          </b-col>
          <b-col md="2 px-0">
            <b-card class="m-3 sticky-top">
              <b-row>
                <b-col xl="12" v-if="!dontSave" class="mb-2">
                  <b-button @click="handleSave" :disabled="receipt.id != ''" variant="success" block>
                    <i class="fa fa-save" aria-hidden="true"></i>
                    {{ receipt.id != '' ? 'Đã lưu phiếu' : 'Lưu phiếu' }}
                  </b-button>
                </b-col>
                <b-col xl="12" v-if="!dontSave" class="mb-2">
                  <b-button @click="doPrint" variant="primary" block>
                    <i class="fa fa-print" aria-hidden="true"></i>
                    In phiếu
                  </b-button>
                </b-col>
                <b-col xl="12">
                  <b-button @click="doBack" block>
                    <i class="fa fa-long-arrow-alt-left" aria-hidden="true"></i>
                    Trở về
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </block>
      <preview @doSave="handleSaveFromPreview" ref="preview"></preview>
    </div>
  </div>
</template>
<script>
import { customerService, productService, manufactureService, receiptService } from '@/_services';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';

import Preview from './__Preview';

export default {
  name: 'receipt-add-in',
  components: {
    ckeditor: CKEditor.component,
    Preview
  },
  data() {
    return {
      receiptBillDetails: [],
      receipt: {
        id: '',
        code: '',
        customer: '',
        date: new Date(),
        note: ''
      },
      dontSave: false,
      manufacture: {},
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          'heading',
          '|',
          'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor',
          '|',
          'bold',
          'italic',
          'link',
          'underline',
          'strikethrough',
          '|',
          'alignment',
          'bulletedList',
          'numberedList',
          'blockQuote',
          '|',
          'indent',
          'outdent',
          'link',
          'insertTable',
          'tableColumn',
          'tableRow',
          'mergeTableCells'
        ]
      },
      back: -1
    };
  },
  created() {},
  mounted() {
    if (this.$route.query.manufacture) {
      manufactureService.findOne(this.$route.query.manufacture).then(res => {
        let manufacture = res.data;

        let oldReceiptBillDetails = manufacture.receiptBillDetails;
        let quantityProduce = 0;
        for (let i = 0; i < oldReceiptBillDetails.length; i++) {
          const element = oldReceiptBillDetails[i];
          quantityProduce += element.quantity;
        }

        let quantity = 0;
        if (quantityProduce >= manufacture.quantityProduce) {
          quantity = manufacture.quantityProduce;
          var self = this;
          this.dontSave = true;
          this.$swal({
            title: 'Lỗi nhập kho',
            text: 'Số lượng sản xuất ra đã nhập kho',
            confirmButtonText: 'OK',
            reverseButtons: true
          }).then(function(result) {
            if (result.value) {
              self.$router.go(self.back);
            }
          });
        } else {
          quantity = manufacture.quantityProduce - quantityProduce;
        }

        let position = '';
        let totalKgWrap = 0;
        if (manufacture.product && manufacture.product.info && manufacture.product.info.id) {
          position = manufacture.product.info.position;
          totalKgWrap = manufacture.product.info.totalKgWrap;
        }
        this.receiptBillDetails.push({
          product: manufacture.product,
          productCustom: manufacture.productCustom,
          reason: manufacture.reason,
          reasonId: manufacture.reasonId,
          color: manufacture.color,
          colorCode1: manufacture.colorCode1,
          colorCode2: manufacture.colorCode2,
          quota: manufacture.quota,
          colorText: manufacture.colorText,
          gramHank: manufacture.productSpecify.gramHank,
          unit: manufacture.unit,
          length: manufacture.length,
          totalKgWrap: totalKgWrap,
          position: position,
          productSpecify: manufacture.productSpecify,
          quantity: quantity,
          order: manufacture.order,
          manufacture: {
            id: manufacture.id,
            code: manufacture.code
          },
          edit: true
        });
        this.manufacture = manufacture;
        this.receipt.manufacture = manufacture;
        this.receipt.order = manufacture.order;
        this.receipt.customer = manufacture.customer;
      });
    }
  },
  methods: {
    fetchData() {},
    getCustomer(keyword, cb) {
      customerService.findAll({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    getProduct(keyword, cb) {
      productService.findAll({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    productReceiptAddRow() {
      this.receiptBillDetails.push({
        product: '',
        color: '',
        colorCode1: '',
        colorCode2: '',
        gramMet: 0,
        metKg: 0,
        gramHank: 0,
        unit: 'sợi',
        length: 0,
        totalKgWrap: 0,
        position: '',
        productSpecify: '',
        quantity: 0,

        edit: true
      });
    },
    productReceiptDeleteRow(index, item) {
      if (item.edit) {
        this.receiptBillDetails.splice(index, 1);
      } else {
        this.$swal({
          title: 'Bạn có chắc thực hiện thao tác này?',
          text: 'Bạn sẽ không thể hoàn nguyên điều này!!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Không',
          reverseButtons: true
        }).then(function(result) {
          if (result.value) {
            alert('contact dev');
          }
        });
      }
    },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
    },
    validateReceipt() {
      var self = this;
      return new Promise(async (resolve, reject) => {
        let validate = await self.$refs.csInfo.validate();
        self.receiptBillDetails.forEach(item => {
          if (
            !item.product ||
            !item.product.id ||
            !item.productSpecify ||
            !item.productSpecify.id ||
            !item.color ||
            !item.color.id
          ) {
            validate = false;
          }
        });
        if (validate) {
          resolve();
        } else {
          reject();
        }
      });
    },
    async handleSave() {
      await this.validateReceipt()
        .then(async () => {
          await this.doSave();
        })
        .catch(() => {
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    async handleSaveFromPreview(cb) {
      await this.validateReceipt()
        .then(async () => {
          await this.doSave();
          cb();
        })
        .catch(() => {
          cb();
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    productChange(row) {
      row.productSpecify = '';
      row.price = 0;
      row.loaded = false;
    },
    productSpecifyChange() {},
    productColorChange() {},
    handelChoosePrice(price) {
      if (this.receiptBillDetailselect) this.receiptBillDetailselect.price = price;
    },
    doSave() {
      let receipt = Object.assign({}, this.receipt);
      receipt.customer = {
        id: this.receipt.customer.id
      };
      let receiptBillDetails = [];
      this.receiptBillDetails.forEach(element => {
        let tmp = Object.assign({}, element);
        tmp.product = {
          id: element.product.id
        };
        tmp.productSpecify = {
          id: element.productSpecify.id
        };
        receiptBillDetails.push(tmp);
      });
      this.$refs.breceipt.block();
      receiptService
        .createIn(receipt, receiptBillDetails)
        .then(res => {
          this.$alertify.success(res.message, {
            duration: 4000
          });
          this.receipt.id = res.data.id;
          this.receipt.code = res.data.code;
          this.receiptBillDetails.forEach(element => {
            element.edit = false;
          });
        })
        .finally(() => {
          this.$refs.breceipt.unBlock();
        });
    },
    doPrint() {
      this.validateReceipt()
        .then(() => {
          this.$refs.preview.visible = true;
          this.$refs.preview.setData(this.receipt, this.receiptBillDetails);
        })
        .catch(() => {
          this.$alertify.error('Vui lòng hoàn thành các trường được khoanh đỏ', {
            duration: 4000
          });
        });
    },
    doBack() {
      var self = this;
      this.$swal({
        title: 'Bạn có chắc thực hiện thao tác này?',
        text: 'Những thao tác bạn vừa thực hiện sẽ không được lưu lại',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Không',
        reverseButtons: true
      }).then(function(result) {
        if (result.value) {
          self.$router.go(self.back);
        }
      });
    },
    getReason(keyword, cb) {
      productService.findReason({ search: keyword }).then(res => {
        cb(res.data.data);
      });
    },
    reasonChange(modal, row) {
      row.reasonId = modal.id;
    }
  }
};
</script>
<style lang="scss">
.ck-editor__editable {
  min-height: 150px;
}
#add-receipt {
  .soft-control {
    .b-table-sticky-header {
      height: 500px;
      max-height: 500px;
    }
  }
}
</style>
